import { render, staticRenderFns } from "./annex-preview.vue?vue&type=template&id=b02852f6&"
import script from "./annex-preview.vue?vue&type=script&lang=js&"
export * from "./annex-preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports